import { createCanBoundTo } from '@casl/react';
import ability from './Ability';

export const Can = createCanBoundTo(ability);